import { isValidCpf } from "@brazilian-utils/is-valid-cpf";
import { isValidCnpj as isValidNumericCnpj } from "@brazilian-utils/is-valid-cnpj";

export function normalizeDocument(value) {
  return value == null
    ? ""
    : String(value).toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 14);
}

export function getDocumentType(value) {
  const document = normalizeDocument(value);
  return /[A-Z]/.test(document) || document.length > 11 ? 2 : 1;
}

export function formatDocument(value) {
  const document = normalizeDocument(value);

  if (getDocumentType(document) === 1) {
    return document
      .slice(0, 11)
      .replace(/^(\d{3})(\d)/, "$1.$2")
      .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  }

  return document
    .replace(/^([A-Z0-9]{2})([A-Z0-9])/, "$1.$2")
    .replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, "$1.$2.$3")
    .replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})\.([A-Z0-9]{3})([A-Z0-9])/, "$1.$2.$3/$4")
    .replace(/([A-Z0-9]{4})(\d{1,2})$/, "$1-$2");
}

function calculateCnpjDigit(base) {
  const weights = base.length === 12
    ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
    : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const sum = base.split("").reduce(
    (total, character, index) => total + (character.charCodeAt(0) - 48) * weights[index],
    0
  );
  const remainder = sum % 11;
  return remainder < 2 ? 0 : 11 - remainder;
}

export function isValidCnpj(value) {
  const document = normalizeDocument(value);
  if (!/^[A-Z0-9]{12}\d{2}$/.test(document)) return false;
  if (!/[A-Z]/.test(document)) return isValidNumericCnpj(document);

  const firstDigit = calculateCnpjDigit(document.slice(0, 12));
  const secondDigit = calculateCnpjDigit(document.slice(0, 12) + firstDigit);
  return document.slice(12) === `${firstDigit}${secondDigit}`;
}

export function isValidDocument(value) {
  const document = normalizeDocument(value);
  return getDocumentType(document) === 1
    ? isValidCpf(document)
    : isValidCnpj(document);
}
